<template>
  <v-row class="my-0">
    <v-col class="my-0 py-0">
      <v-row
        class="my-0"
        align="center"
      >
        <v-col cols="auto">
          <v-img
            :src="require('@/assets/images/ui/opportunity-share-icon.svg')"
            max-width="32"
          />
        </v-col>
        <v-col>
          <div class="title">
            Opportunities raised
          </div>
        </v-col>
        <v-col
          cols="auto"
          class="secondary--text title"
        >
          {{ oppsPublishedNumber }}
        </v-col>
      </v-row>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUser } from '@/types/models/user.model'

@Component
export default class OpportunitiesPublishedNumber extends Vue {
  @Prop() user: IUser

  get oppsPublishedNumber (): number {
    if (!this.user) return 0
    return this.user?.opportunitesPublishedNumber || 0
  }
}
</script>
